<template>
  <div class="logo-container">
    <a href="/df">
      <img src="@/assets/images/icons/df-logo.png" alt="icon" />
    </a>
    <a href="/">
      <img src="@/assets/images/icons/lf-logo.png" alt="icon" />
    </a>
  </div>
</template>

<script>
export default {
  name: "logo-container",
};
</script>

<style lang="scss" scoped>
.logo-container {
  display: flex;
  gap: 22px;

  img {
    max-width: 120px;
    @media (max-width: 767px) {
      max-width: 60px;
    }
  }
}

.mob__menu {
  img {
    max-width: 60px;
  }
}

.modal-overlay {
  .logo-container {
    justify-content: center;
    margin-bottom: 30px;
  }
}

footer {
  .logo-container {
    @media (max-width: 767px) {
      margin: 0 auto;
    }
  }
}
</style>
